module.exports = __webpack_public_path__ + "img/main_title.79cde5b3.png";